import React from 'react';
import {
  dateOrDateTimeFormatter,
} from '../../../utils/formatters';

export default function ClientCardInfo(props) {
  const { selectedItem } = props;
  return (
    <div className="client-card-info">
      <div className="client-card-info-item">
        <div className="client-card-info-item-title">Начало:</div>
        <div className="client-card-info-item-data"> {dateOrDateTimeFormatter(selectedItem.issue_at, false, true)} </div>
      </div>
      <div className="client-card-info-item">
        <div className="client-card-info-item-title">Окончание:</div>
        <div className="client-card-info-item-data"> {dateOrDateTimeFormatter(selectedItem.expiry_at, false, true)} </div>
      </div>
    </div>
  );
}
